import React from 'react';
import { getLabel } from 'utils/getLabel';
import { map, get, find, isEmpty, times } from 'lodash';

// local dependencies
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { Icon } from 'modules/icon-bank';
import { getMemberIconColor } from 'resolvers/hipaaAndCoverage';

/*******************************/

// success view
export const authFlowMemberVerificationFamilyUnitSuccess = ( props ) => {
    return (
			<div className='ui-auth-flow-member-verification-family-unit'>
				{/* title */}
				<div className='ui-auth-flow-member-verification-family-unit__title'>
					{ getLabel( props.titles.title ) }

				</div>

				{ /* members */ }
				<div className='ui-auth-flow-member-verification-family-unit__members'>
					{ !isEmpty( props.members ) ? (
						map( props.members, ( member ) => {

							// get icon color
							const iconColor = getMemberIconColor( {
								relationship: member.relationship,
								coverageStatus: member.coverageStatus,
							} );

							// get relationship title
							const relationship = getLabel(
								get(
									find( props.options.relationship, {
										value: member.relationship,
									} ),
									'title'
								)
							);

							return (
								<div
									key={ member.id }
									className='ui-auth-flow-member-verification-family-unit__members__item'
								>
									{/* icon */}
									<Icon
										className='ui-auth-flow-member-verification-family-unit__members__item__icon'
										name={ member.gender }
										fill={ iconColor }
										stroke={ iconColor }
									/>

									{/* name */}
									<p className='ui-auth-flow-member-verification-family-unit__members__item__name'>
										{ member.name }
									</p>

									{/* relationship */}
									<p className='ui-auth-flow-member-verification-family-unit__members__item__relationship'>
										{ relationship }
									</p>
								</div>
							);
						} )
					) : (
						<div className='ui-auth-flow-member-verification-family-unit__members__title'>
                            { getLabel( props.titles.noData ) }
                        </div>
					)}
				</div>
			</div>
		);
};

// set display name
authFlowMemberVerificationFamilyUnitSuccess.displayName = 'authFlowMemberVerificationFamilyUnitSuccess';

// set default props
authFlowMemberVerificationFamilyUnitSuccess.defaultProps = {
    title: null,
    members: [],
    options: {},
};

// prop types
authFlowMemberVerificationFamilyUnitSuccess.propTypes = {};

/*******************************/

// preloader view
export const authFlowMemberVerificationFamilyUnitPreloader = () => {
    return (
		<div className='ui-auth-flow-member-verification-family-unit-preloader'>
			<div className='ui-auth-flow-member-verification-family-unit-preloader__title'></div>
			<div className='ui-auth-flow-member-verification-family-unit-preloader__data'>
				{ times( 3 ).map( index => {
					return (
						<div key={ index }className='ui-auth-flow-member-verification-family-unit-preloader__data__member'>
							<div className='ui-auth-flow-member-verification-family-unit-preloader__data__member__icon'></div>
							<div className='ui-auth-flow-member-verification-family-unit-preloader__data__member__name'></div>
							<div className='ui-auth-flow-member-verification-family-unit-preloader__data__member__relationship'></div>
						</div>
					);
				} ) }
			</div>

		</div>
    );
};

// set display name
authFlowMemberVerificationFamilyUnitPreloader.displayName = 'authFlowMemberVerificationFamilyUnitPreloader';

// set default props
authFlowMemberVerificationFamilyUnitPreloader.defaultProps = {};

// prop types
authFlowMemberVerificationFamilyUnitPreloader.propTypes = {};

/*******************************/


/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { authFlowMemberVerificationFamilyUnit as AuthFlowMemberVerificationFamilyUnit } from 'ui/views/widgets/authFlowMemberVerificationFamilyUnit';
 *
 * // render
 * <AuthFlowMemberVerificationFamilyUnit propName='propValue'/>
 */
export const authFlowMemberVerificationFamilyUnit = withNetworkState( authFlowMemberVerificationFamilyUnitPreloader, authFlowMemberVerificationFamilyUnitSuccess );
